import styled, { css } from "styled-components";
import type { SpaceProps } from "styled-system";
import { theme } from "../../../../../../common-deprecated/styles/v2/toyota/theme/toyotaTheme";

export const Overflower = styled.div`
    position: relative;
    width: 100%;
    height: 44px;
    overflow-x: hidden;
    margin-bottom: ${theme.space[3]}px;
`;

const overFlowButtonStyles = css`
    position: absolute;
    top: 0;
    width: 42px;
    height: 42px;
    margin: ${theme.space[0]};
    color: ${theme.colors.grey7};
    background: ${theme.colors.primaryWhite};
    z-index: ${theme.zIndex.gradesNav - 1};

    span {
        position: absolute;
        top: 3px;
        margin: ${theme.space[0]};
        padding: ${theme.space[0]};
    }

    &:focus,
    &:hover {
        color: ${theme.colors.grey7};
    }

    .professional-theme & {
        color: ${theme.colors.primaryWhite};
        background: ${theme.colors.primaryBlack};
    }

    .bz & {
        color: ${theme.colors.primaryWhite};
        background: ${theme.colors.bz4x};
    }
`;

export const LeftButton = styled.button<{ visible?: boolean }>`
    display: ${({ visible }) => (visible ? "block" : "none")};
    ${overFlowButtonStyles};
    left: 0;
    span {
        left: 0;
    }

    html[dir="rtl"] & {
        left: auto;
        right: 0;
        span {
            left: auto;
            right: 0;
        }
    }
`;

export const RightButton = styled.button<{ visible?: boolean }>`
    display: ${({ visible }) => (visible ? "block" : "none")};
    ${overFlowButtonStyles};
    right: 0;
    span {
        right: 0;
    }

    html[dir="rtl"] & {
        left: 0;
        right: auto;
        span {
            left: 0;
            right: auto;
        }
    }
`;

export const Wrapper = styled.div`
    position: relative;
    min-width: 100%;
    height: 100%;
    white-space: nowrap;
    border-bottom: 2px solid ${theme.colors.grey7};
    vertical-align: middle;

    .professional-theme & {
        border-bottom: 2px solid ${theme.colors.grey1};
    }

    .bz & {
        border-color: ${theme.colors.grey2};
    }
`;

export const Tab = styled.button<{ isActive?: boolean } & SpaceProps>`
    position: relative;
    width: auto;
    min-width: 0;
    max-width: 100%;
    margin-bottom: ${theme.space[0]};
    margin-left: ${theme.space[4]}px;
    padding-bottom: ${theme.space[2]}px;
    text-align: center;
    color: inherit;
    white-space: nowrap;
    background-color: transparent;
    border: none;
    &:first-child {
        margin-left: 0;
    }
    ${({ isActive }) =>
        isActive &&
        css`
            font-family: ${theme.fonts.regular};
            &::after {
                position: absolute;
                bottom: -2px;
                left: 0;
                width: 100%;
                height: 2px;
                content: "";
                background: ${theme.colors.primaryRed};
            }
        `};

    .bz & {
        ${({ isActive }) =>
            isActive &&
            css`
                &::after {
                    background: ${theme.colors.bz4x};
                }
            `};
    }

    html[dir="rtl"] & {
        margin-left: 0;
        margin-right: ${theme.space[4]}px;
        &:first-child {
            margin-right: 0;
        }
        ${({ isActive }) =>
            isActive &&
            css`
                &::after {
                    left: auto;
                    right: 0;
                }
            `};
    }
`;
